
import React, { useState, useEffect, useMemo, useRef } from 'react'
import { Formik, Field, ErrorMessage, useFormik } from 'formik';
import { CreateOutlet, GetBrandOutletsList } from '../../../services/company_panel/outletService';
import { GetAllCountries, GetAllStates, GetAllCities } from '../../../services/globalService';
import { Link, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import Swal from "sweetalert2"
import Breadcrums from '../../../components/company_panel/common/breadcrumbs';
import $ from "jquery";
import TimePicker from "@ashwinthomas/react-time-picker-dropdown";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { capitalizeAllFirstLetters, capitalizeFirstLetter, formatToTwoDecimals, getBrandId, getCompany, getOutletId, showPrice, SpecialCharacter } from '../../../helpers/commonFunctions';
import GoogleMapModal from '../../outlet/GoogleMapModal';
import { GetBrandList } from '../../../services/brandService';
import { Dropdown } from 'semantic-ui-react';

import { Table, Button, Modal, Form, } from 'react-bootstrap';
import axios from 'axios';
import { GetAllParentCategories } from '../../../services/company_panel/menuCategoryService';
import { GetAllActiveTaxes, GetTaxList } from '../../../services/company_panel/setting/taxConfigurationService';
import { GetActiveOrderModes, GetOrderModeList } from '../../../services/company_panel/setting/orderModeConfigurationService';
import { CreateAddOn, EditAddOn, GetAddOnCategoryList, GetAllAddOnCategory, SingleAddOn } from '../../../services/company_panel/menuAddOnCategory';
import { GetAllInventories, GetSingleInventory } from '../../../services/company_panel/inventoryService';
import CustomMultiSelect from '../../../components/common/CustomMultiSelect';
import { GetAggregatorAllDetails } from "../../../services/company_panel/setting/aggregatorConfigurationService";
import { GetOrderModeAllDetails } from "../../../services/company_panel/setting/orderModeConfigurationService";

import * as Yup from "yup";
import { TagPicker } from 'rsuite';
// import Select from "react-select";
// import Dropdown from "react-dropdown";
// import "react-dropdown/style.css";

const AddOnsEdit = () => {
    const navigate = useNavigate()
    const [btnClicked, setBtnClicked] = useState(false);
    const [page, setPage] = useState(1);
    const [searchParams] = useSearchParams();
    const params = useParams()
    const [show, setShow] = useState(false);
    const [recipes, setRecipes] = useState([]);
    const [taxList, setTaxList] = useState([]);
    const [inventoryList, setInventoryList] = useState([]);
    const [rawList, setRawList] = useState({});
    const [showDefault, setShowDefault] = useState({})
    const [formikData, setFormikData] = useState({})

    const [formData, setFormData] = useState({
        usageUOM: '',
        quantity: '',
        price: '',
        calories: '',
        raw_material_price: '',
        raw_material_calories: ''
    });
    const [orderMode, setOrderMode] = useState([])

    const [editIndex, setEditIndex] = useState(-1);
    const [isBrandChanged, setIsBrandChanged] = useState(false);

    const handleShow = () => setShow(true);
    // const handleClose = () => setShow(false);
    // const currentBrand = getBrandId();
    const [currentBrand] = useState(getBrandId());
    const [allOrderMode, setAllOrderMode] = useState([]);
    const [allAggregator, setAllAggregator] = useState([]);

    const [outletData, setOutletData] = useState({});
    const [outListData, setOutListData] = useState([]);
    const [dataFormatted, setDataFormatted] = useState(false);
    // const [outlets, setOutlets] = useState([]);
    const [refreshPricing, setRefreshPricing] = useState(false);
    const [btnDisable, setBtnDisable] = useState(false);
    const selectedRecipesRef = useRef([]);

    // const [rawMaterialSearch, setRawMaterialSearch] = useState('');

    // useMemo(() => {
    //     document.addEventListener('brand-changed', function () {
    //         if (currentBrand != getBrandId()) {
    //             navigate(`/company/menu/menu/add_ons/list/${searchParams.get('pageno') || 1}`);
    //         }
    //         setIsBrandChanged(!isBrandChanged);
    //     });
    // },[]);

    useMemo(() => {
        document.addEventListener('brand-changed', function () {
            setIsBrandChanged(!isBrandChanged);
        });
        if (currentBrand != getBrandId()) {
            navigate(`/company/menu/menu/add_ons/list/${searchParams.get('pageno') || 1}`);
        }
    });


    const saveData = (e) => {
        e.preventDefault();
        const newData = {
            rawMaterial: {
                id: rawList.id,
                name: rawList?.name,
            },
            usageUOM: formData?.usageUOM,
            quantity: formData?.quantity,
            price: formData?.price,
            calories: formData?.calories,
            orderMode: orderMode,
            raw_material_price: formData?.raw_material_price,
            raw_material_calories: formData?.raw_material_calories,
            display_rank: formData?.display_rank
        }

        if (editIndex != -1) {
            const addOnList = addOnDataList;
            addOnList[editIndex] = newData;
            setAddOnDataList(prevState => addOnList);
            setEditIndex(prevState => -1);
        } else {
            setAddOnDataList(prevState => [
                ...prevState,
                newData
            ]);
        }
        resetForm();
    }

    const breadcrumbs = [
        {
            title: "Menu",
            url: "/company/menu/menu/categories/list/1"
        },
        {
            title: "Add-Ons",
            url: `/company/menu/menu/add_ons/list/${searchParams.get('pageno') || 1}`
        },
        {
            title: "Add-Ons Listing",
            url: `/company/menu/menu/add_ons/list/${searchParams.get('pageno') || 1}`
        },
        {
            title: searchParams.get('copy') ? "Create an Add-On" : "Edit an Add-On",
            url: ""
        },
    ]

    const [submitted, setSubmitted] = useState(false)
    const [brandList, setBrandList] = useState([])
    const [addMoreCount, setAddMoreCount] = useState([1]);

    useEffect(() => {
        const formData = new FormData();
        formData.append('brand_id', getBrandId());
        GetAllAddOnCategory(formData)
            .then(data => {
                // setBrandList(data && data.data && data.data.response ? data.data.response : []);
                const brandOptions = data?.data?.response?.map(row => ({
                    label: capitalizeAllFirstLetters(row.name),
                    value: row.id,
                }));
                setBrandList(brandOptions || []);
            })
            .catch(error => {
                console.log("error ====> ", error);
            });
    }, [isBrandChanged]);

    useEffect(() => {
        const formData = new FormData()
        formData.append('brand_id', getBrandId());
        formData.append('type', 'tax-groups');
        GetAllActiveTaxes(formData).then(data => {
            setTaxList(data && data.data && data.data.response ? data.data.response : [])
        }).catch(error => {
            console.log("error ====> ", error);
        })
    }, [isBrandChanged]);

    

    // Tab script
    useEffect(() => {
        if (
          formRef.current &&
            showDefault &&
            showDefault?.pricing_type === "ask_for_price" &&
            formRef?.current?.values?.pricingType === "fixed"
        ) {
          if (page === 2 && formRef.current) {
            let outletPricesValues = formRef.current?.values?.outlet_prices?.map(
              (item) => {
                return { ...item, price: formRef.current?.values?.short_code };
              }
            );
            formRef.current.setFieldValue("outlet_prices", outletPricesValues);
    
            let aggregatorPricesValues =
              formRef.current?.values?.aggregator_prices?.map((item) => {
                return { ...item, price: formRef.current?.values?.short_code };
              });
            formRef.current.setFieldValue(
              "aggregator_prices",
              aggregatorPricesValues
            );
          }
        }
        // a changed step-1 price changes the outlet specific prices that are set; empty ones stay empty
        const basePrice = formRef.current?.values?.short_code;
        if (page === 3 && formRef.current && basePriceRef.current !== undefined && basePrice !== "" && basePrice != null && Number(basePrice) !== Number(basePriceRef.current)) {
          basePriceRef.current = basePrice;
          formRef.current.setFieldValue(
            "outlet_prices_specific",
            formRef.current.values?.outlet_prices_specific?.map((item) => ({
              ...item,
              orderMode: item?.orderMode?.map((record) => ({
                ...record,
                price: record?.price === "" || record?.price == null ? record?.price : basePrice,
              })),
              aggregator: item?.aggregator?.map((record) => ({
                ...record,
                price: record?.price === "" || record?.price == null ? record?.price : basePrice,
              })),
            }))
          );
        }
    }, [page, refreshPricing, showDefault]);


    const nextStep = (selected) => {
        setPage(page + 1);
        var currentStepNum = $('#checkout-progress').data('current-step');
        var nextStepNum = (currentStepNum + 1);
        var currentStep = $('.step.step-' + currentStepNum);
        var nextStep = $('.step.step-' + nextStepNum);
        var progressBar = $('#checkout-progress');
        $('.btn-prev').show();
        $('#section' + currentStepNum).toggle();
        $('#section' + nextStepNum).toggle();
        if (nextStepNum == 5) {
            $(this).toggle();
            $('.btn-next').hide();
        }

        $('.checkout-progress').removeClass('.step-' + currentStepNum).addClass('.step-' + (currentStepNum + 1));

        currentStep.removeClass('active').addClass('valid');
        currentStep.find('span').addClass('opaque');
        currentStep.find('.fa.fa-check').removeClass('opaque');

        nextStep.addClass('active');
        progressBar.removeAttr('class').addClass('step-' + nextStepNum).data('current-step', nextStepNum);
    }
    const prevStep = (selected) => {
        setPage(page - 1);
        var currentStepNum = $('#checkout-progress').data('current-step');
        var prevStepNum = (currentStepNum - 1);
        var currentStep = $('.step.step-' + currentStepNum);
        var prevStep = $('.step.step-' + prevStepNum);
        var progressBar = $('#checkout-progress');
        $('.btn-next').removeClass('disabled');
        $('#section' + currentStepNum).toggle();
        $('#section' + prevStepNum).toggle();
        if (currentStepNum == 5) {
            $('.btn-next').toggle();
        }

        // if (currentStepNum == 4) {
        //     $('.btn-prev').hide();
        // }
        // if (currentStepNum == 3) {
        //     $('.btn-prev').hide();
        // }
        if (currentStepNum == 2) {
            $('.btn-prev').hide();
        }
        if (currentStepNum == 1) {
            $('.btn-prev').hide();
            return false;
        }
        if (prevStepNum == 1) {
            $(this).addClass('disabled');
        }
        $('.checkout-progress').removeClass('.step-' + currentStepNum).addClass('.step-' + (prevStepNum));

        currentStep.removeClass('active');
        prevStep.find('span').removeClass('opaque');
        prevStep.find('.fa.fa-check').addClass('opaque');

        prevStep.addClass('active').removeClass('valid');
        progressBar.removeAttr('class').addClass('step-' + prevStepNum).data('current-step', prevStepNum);
    };
 
    const [activeStep, setActiveStep] = useState(1);
    
    // Function to handle step changes — jump directly to any tab in one click.
    const handleStepChange = (step) => {
        // show only the chosen section, hide the rest
        for (let i = 1; i <= 5; i++) {
            $('#section' + i).css('display', i === step ? 'block' : 'none');
        }
        // keep the hidden jQuery stepper in sync so Back / Next continue from here
        $('#checkout-progress').removeAttr('class').addClass('step-' + step).data('current-step', step);
        // page drives Back / Next button visibility (rendered via page > 1 / page < 5)
        setPage(step);
        setActiveStep(step);
    };

    // const [orderList, setOrderList] = useState([]);
    const [addOnDataList, setAddOnDataList] = useState([]);
    // const [menuRecipes, setMenuRecipes] = useState([])
    const formRef = useRef();
    // step-1 price the outlet specific prices last followed
    const basePriceRef = useRef();

    const [recipeEditableIndex, setRecipeEditableIndex] = useState(null);

    useEffect(() => {
        if (page === 2) {
            if (formRef?.current?.values) {
                if (formRef?.current?.values?.pricingType === "ask_for_price") {
                    setBtnDisable(false);
                } else {
                    setTimeout(() => {
                        setBtnDisable(!isAllPriceFilled(formRef?.current?.values));
                    }, 500);
                }
            }
        }
    }, [page, formRef?.current?.values]);

    const resetForm = () => {
        setRawList({ id: 0, name: '' });
        setOrderMode('');
        setShow(false);
    }

    // The recipe picker matches on the raw material's name or the SKU shown in
    // brackets after it, so either one finds the row.
    const searchRawMaterial = (options, query) => {
        const term = String(query || '').trim().toLowerCase();
        if (!term) return options;
        return options.filter(option =>
            String(option.text ?? '').toLowerCase().includes(term)
            || String(option.description ?? '').toLowerCase().includes(term)
        );
    };

    const handleChangeModel = (value) => {
        if (Number(value)) {
            GetSingleInventory({ id: Number(value), outlet_id: getOutletId() })
                .then(data => {
                    let inventory = data?.data?.response || {};
                    const inventoryData = inventory?.inventory_unit_converisons.filter((item) => {
                        return item.unit_type == 'Usage Unit';
                    });
                    let myData = { ...formik?.values };
                    myData.rawMaterial = value;
                    myData.usageUOM = inventoryData[0]?.uomDetail?.uom_code;
                    myData.quantity = 1;
                    myData.price = inventoryData[0]?.price;
                    myData.calories = inventoryData[0]?.calories;
                    myData.raw_material_price = inventoryData[0]?.price;
                    formik.setValues(myData);
                })
                .catch(error => {
                    console.log("error ====> ", error);
                });
        }
        else {
            formik.setFieldValue("rawMaterial", "");
        }
    };


    const formik = useFormik({
        validationSchema: Yup.object().shape({
            rawMaterial: Yup.string().trim().required("Raw material is required"),
            quantity: Yup.number().required("Quantity is required"),
        }),
        initialValues: {
            rawMaterial: '',
            usageUOM: '',
            quantity: '',
            price: '',
            calories: '',
            orderMode: [],
            raw_material_price: 0
        },
        onSubmit: (values, { resetForm }) => {

            let recipeEditIndex = -1;
            let recipeEditInventoryId;

            if (recipeEditableIndex === null) {
                setAddOnDataList(prevState => [
                    ...prevState,
                    values
                ]);
            } else {
                recipeEditIndex = recipeEditableIndex;
                recipeEditInventoryId = addOnDataList[recipeEditIndex].rawMaterial; 
                let existingData = [...addOnDataList];
                existingData[recipeEditableIndex] = values;
                setAddOnDataList(existingData);
                setRecipeEditableIndex(null);
            }
            handleClose();

            setInventoryList(prev =>{
                return prev?.map(inventory =>{
                    if(inventory.id == values.rawMaterial){
                        return {
                            ...inventory,
                            isDisabled: true
                        }
                    }else if(recipeEditIndex > -1 && inventory.id == recipeEditInventoryId){
                        return {
                            ...inventory,
                            isDisabled: false
                        }
                    }
                    return inventory;
                })
            })
        },
    });

    const handleClose = () => {
        setShow(false);
        formik?.resetForm();
        setRecipeEditableIndex(null);
    };

    const handleRemoveItem = (index) => {
        const recipeRemoved = addOnDataList[index].rawMaterial;
        setInventoryList(prev =>{
            return prev?.map(inventory =>{
                if(inventory.id == recipeRemoved){
                    return {
                        ...inventory,
                        isDisabled: false
                    }
                }
                return inventory;
            })
        })

        let updatedList = [...addOnDataList];
        updatedList.splice(index, 1);
        setAddOnDataList(updatedList);
    };

    const handleEditItem = (index) => {
        setRecipeEditableIndex(index);
       formik?.setValues(addOnDataList[index]);
        setShow(true);
    };

    const getRecordFromList = (list, id) => {
        return list.filter(item => Number(item.id) === Number(id))[0];
    }

    useEffect(() => {
        const fetchData = async (tempOutletData) => {
            try {
                const [
                    aggregatorResponse,
                    orderModeResponse,
                    defaultData
                ] = await Promise.all([
                    GetAggregatorAllDetails({ brand_id: getBrandId() }),
                    GetOrderModeAllDetails({ brand_id: getBrandId() }),
                    SingleAddOn({ id: params?.id }),
                ]);

                console.log('=======API executing');
                //addons details work
                const myData = defaultData?.data?.response;
                let data = {};
                let menuReciepes = [];
                if (defaultData) {
                    setShowDefault(myData ? myData : {});
                    menuReciepes = myData?.menu_add_on_reciepes && myData?.menu_add_on_reciepes.length > 0 ? myData?.menu_add_on_reciepes : [];
                   

                    data = {
                        ...data,
                        outlet_name: myData?.name || "",
                        outlet_name_ar: myData?.name_ar || "",
                        brand_id: myData?.categories || [],
                        tax_id: myData?.tax_group_id || "",
                        short_code: Number(myData?.price) || 0,
                        short_description: myData?.short_description || "",
                        short_description_ar: myData?.short_description_ar || "",
                        display_rank: myData?.display_rank || "",
                        pricingType: myData?.pricing_type || "",
                    };
                    basePriceRef.current = data.short_code;
                }
                const uomsData = myData.uoms;
                const selectedRecipesId = [];

                let addedRecipe = menuReciepes.map((record) => {
                    const unitsData = (record?.inventory?.inventory_unit_converisons || []).filter(item => item?.unit_ === "Usage Unit")[0];
                    const UOM = uomsData.filter(item => item.id === unitsData?.uom)[0];
                    // console.log("ramveer **", unitsData, record);
                    const obj = {
                        rawMaterial: record?.inventory_id,
                        usageUOM: UOM?.uom_code,
                        quantity: record?.quantity,
                        price: unitsData?.price * record?.quantity,
                        raw_material_price: unitsData?.price,
                        calories: unitsData?.calor,
                        orderMode: Array.isArray(record?.menu_add_on_reciepe_order_modes) ? record?.menu_add_on_reciepe_order_modes?.map((orderModeItem) => orderModeItem?.order_mode) : [],
                    }
                    selectedRecipesId.push(record?.inventory_id);
                    return obj;
                });
                selectedRecipesRef.current = selectedRecipesId;
                setAddOnDataList(addedRecipe);
                setBtnDisable(false);

                //pricing work
                const aggregatorData = aggregatorResponse?.data?.response || []; 
                const orderModeData = orderModeResponse?.data?.response || [];

                const getOutletPriceData = (record, type = "orderMode") => {
                    const result = myData?.add_on_outlet_default_prices?.filter(
                        (item) => type === "aggregator" ? item?.aggregator_id === record?.id : item?.order_mode_id === record?.id
                    )[0];
                    return result;
                };
                setAllAggregator(aggregatorData);
                setAllOrderMode(orderModeData);

                if (formRef?.current) {
                    data = {
                        ...data,
                        "outlet_prices" : orderModeData.map((record) => {
                            const result = getOutletPriceData(record);
                            return {
                                order_mode_id: record.id,
                                price: result?.price,
                            };
                        })
                    }
                    data = {
                        ...data,
                        "aggregator_prices": aggregatorData.map((record) => {
                            const result = getOutletPriceData(record, "aggregator");
                            return {
                                aggregator_id: record.id,
                                price: result?.price,
                            };
                        })
                    }

                    // rows saved from one outlet group share a grouping_key; rows without one fall back to their outlet
                    const groupingKeys = [];
                    myData?.add_on_outlet_specific_prices?.forEach((item) => {
                        const groupingKey = item.grouping_key || String(item.outlet_id);
                        if (groupingKeys.indexOf(groupingKey) === -1) {
                            groupingKeys.push(groupingKey);
                        }
                    });
                    const outletPreselectedData = [];
                    groupingKeys.forEach((groupingKey) => {
                        const groupData = myData?.add_on_outlet_specific_prices?.filter((item) => {
                            return (item.grouping_key || String(item.outlet_id)) === groupingKey;
                        });
                        const orderModeSelectedData = groupData.filter((item) => item?.order_mode_id);
                        const aggregatorSelectedData = groupData.filter((item) => item?.aggregator_id);
                        const getFilledPrice = (id, type = "orderMode") => {
                            let result = {};
                            if (type === "aggregator") {
                                result = aggregatorSelectedData?.filter((item) => item?.aggregator_id === id)[0];
                            } else {
                                result = orderModeSelectedData?.filter((item) => item?.order_mode_id === id)[0];
                            }
                            return result || {};
                        };
                        const record = {
                            grouping_key: groupData[0]?.grouping_key,
                            outlet: [...new Set(groupData.filter((item) => item.outlet_id != null).map((item) => Number(item.outlet_id)))],
                            orderMode: orderModeData.map((record) => ({
                                name: record.name,
                                order_mode_id: record?.id,
                                price: getFilledPrice(record?.id)?.price,
                            })),
                            aggregator: aggregatorData.map((record) => ({
                                name: record.name,
                                aggregator_id: record?.id,
                                price: getFilledPrice(record?.id, "aggregator")?.price,
                            })),
                        };
                        
                        tempOutletData = initialOutletIdsSetup(
                            record.outlet,
                            tempOutletData
                        );
                        outletPreselectedData.push(record);
                    });

                    setOutletData(tempOutletData);
                    let arr = [];
                    Object.entries(tempOutletData).forEach(([outletId, data]) => {
                        arr.push({
                            label: data?.name,
                            value: Number(outletId),
                            valid: data.value,
                        });
                    });
                    setOutListData(arr);

                    if (outletPreselectedData.length === 0) {
                        outletPreselectedData.push({
                            outlet: [],
                            orderMode: orderModeData.map((record) => ({
                                name: record.name,
                                order_mode_id: record?.id,
                                price: "",
                            })),
                            aggregator: aggregatorData.map((record) => ({
                                name: record.name,
                                aggregator_id: record?.id,
                                price: "",
                            })),
                        });
                    }
                    data = {
                        ...data,
                        "outlet_prices_specific": outletPreselectedData
                    }
                    setFormikData(data);
                    setDataFormatted(true);
                }

                // ✅ re-run validation after populating values
                // formRef?.current?.validateForm();

                console.log('=======API completed');
            } catch (error) {
                console.log("error ====> ", error);
            }
        };

         GetBrandOutletsList({ brand_ids: JSON.stringify([getBrandId()]) })
            .then((data) => {
                // setOutlets(
                //   data && data.data && data.data.response ? data.data.response : []
                // );
        
                const outletsList =
                  data && data.data && data.data.response ? data.data.response : [];
                // let dropDownList = outletsList.map((item) => ({ label: item?.outlet_name, value: Number(item?.id), valid : true }));
                // setOutListData(dropDownList);
        
                let obj = {};
                outletsList.forEach((outlet) => {
                  obj[Number(outlet.id)] = { name: outlet.short_code ? `${outlet.outlet_name} (${outlet.short_code})` : outlet.outlet_name, short_code: outlet.short_code, value: true };
                });
                setOutletData(obj);
        
                fetchData(obj)
                .then(()=>{
                    getAllInventories();
                })
                .catch(error=> console.log(error));

              })
            .catch((error) => {
                console.log("error ====> ", error);
            });
        
    }, [isBrandChanged]);

    const getAllInventories = ()=>{
        const formData = new FormData();
        formData.append("brand_id", getBrandId());
        GetAllInventories(formData)
        .then((data) => {
            const inventories = data?.data?.response?.rows?.map(inventory => ({
                ...inventory,
                label: inventory.item_name,
                value: inventory.id,
                isDisabled: selectedRecipesRef.current?.includes(inventory.id)
            }))
            setInventoryList(inventories);
        })
        .catch((error) => {
            console.log("error ====> ", error);
        });
    }

    const onChangeQuantity = (quantity, values) => {
        formik.setFieldValue(
            'price', values.raw_material_price * quantity
        )
    }

    const isExpired = (createdAt, shelfLife) => {
        const createdDate = new Date(createdAt);
        const expirationDate = new Date(createdDate);
        expirationDate.setDate(createdDate.getDate() + parseInt(shelfLife, 10));
        return expirationDate < new Date();
    };

    const initialOutletIdsSetup = (outletIds, tempOutletData) => {
        outletIds.forEach((outletId) => {
            tempOutletData[outletId] = {
                ...tempOutletData[outletId],
                value: false,
            };
        });

        return { ...tempOutletData };
    };

    const onChangeOutlet = (previousOutletIds, outletIds) => {
        let tempOutletData = { ...outletData };

        previousOutletIds &&
        previousOutletIds?.forEach((outletId) => {
            tempOutletData[outletId] = {
            ...tempOutletData[outletId],
            value: true,
            };
        });
        outletIds.forEach((outletId) => {
        tempOutletData[outletId] = {
            ...tempOutletData[outletId],
            value: false,
        };
        });
        setOutletData(tempOutletData);

        let arr = [];
        Object.entries(tempOutletData).forEach(([outletId, data]) => {
        arr.push({
            label: data?.name,
            value: Number(outletId),
            valid: data.value,
        });
        });
        setOutListData(arr);
    };

    // A new outlet group starts from the step-2 default prices, matched order mode by
    // order mode and aggregator by aggregator; blank where step 2 is blank.
    const stepTwoPrice = (list, idKey, id) => {
        const match = (list || []).find((row) => String(row?.[idKey]) === String(id));
        return match?.price !== undefined && match?.price !== null ? match.price : '';
    };

    const addPriceBox = (setFieldValue, values) => {
        const current = formRef.current?.values || {};
        const newArr = [...values];
        newArr.push({
            outlet: [],
            orderMode: allOrderMode.map((record) => ({
                name: record.name,
                order_mode_id: record?.id,
                price: stepTwoPrice(current.outlet_prices, 'order_mode_id', record?.id),
            })),
            aggregator: allAggregator.map((record) => ({
                name: record.name,
                aggregator_id: record?.id,
                price: stepTwoPrice(current.aggregator_prices, 'aggregator_id', record?.id),
            })),
        });
        setFieldValue("outlet_prices_specific", newArr);
   };

    // Outlets are listed, tagged and named in short code order (numbers compared as numbers, PSK-2 before PSK-10)
    const compareOutletCodes = (a, b) => String(outletData[a]?.short_code ?? '').localeCompare(String(outletData[b]?.short_code ?? ''), undefined, { numeric: true, sensitivity: 'base' });

    // Removing a group only changes the form: nothing is saved until the add-on is
    // submitted, so the confirmation says so and lists the group's outlets.
    const confirmRemovePriceBox = (index, setFieldValue, values) => {
        const outletIds = values?.[index]?.outlet || [];
        const count = outletIds.length;
        // names are user entered and go into html, so escape them
        const escapeHtml = (text) => String(text ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
        const names = [...outletIds]
            .sort(compareOutletCodes)
            .map((id) => outListData.find((outlet) => Number(outlet.value) === Number(id))?.label)
            .filter(Boolean)
            .map((name) => capitalizeAllFirstLetters(name));
        // a big group scrolls inside the dialog instead of making it very tall
        const outletList = names.length
            ? `<div style="display:flex;flex-wrap:wrap;justify-content:center;gap:6px;max-height:150px;overflow-y:auto;margin:14px 0 6px;padding:2px">${names
                .map((name) => `<span style="padding:3px 10px;border-radius:999px;background:#f1f4f9;border:1px solid #e2e8f0;color:#334155;font-size:13px;white-space:nowrap">${escapeHtml(name)}</span>`)
                .join('')}</div>`
            : '';
        Swal.fire({
            customClass: 'swal-wide',
            title: `Remove Pricing Group ${index + 1}?`,
            html: `Are you sure you want to remove this pricing group${count ? ` for <b>${count} outlet${count > 1 ? 's' : ''}</b>` : ' for outlets'}?${outletList || '<br/>'}<small style="color:#7b8794">Final changes will happen when you submit.</small>`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#2f9bff',
            cancelButtonColor: '#dc3545',
            confirmButtonText: 'Yes, remove it',
            cancelButtonText: 'Cancel',
        }).then((result) => {
            if (!result.isConfirmed) return;
            // read the groups again: they may have changed while the dialog was open
            removePriceBox(index, setFieldValue, formRef.current?.values?.outlet_prices_specific || values);
        });
    };

    const removePriceBox = (index, setFieldValue, values) => {
        let newArr = [...values];
        onChangeOutlet(newArr[index].outlet, []);
        newArr.splice(index, 1);
        setFieldValue("outlet_prices_specific", newArr);
    };


    const isAllPriceFilled = (values) => {
        
        console.log(values?.outlet_prices, '======outlet prices');
        console.log(values?.aggregator_prices, '========aggregator prices');
        
        let outletPricesValid = true;
        let aggregatorPricesValid = true;

        if (values?.outlet_prices?.length && values?.aggregator_prices?.length) {
            
            for (let i = 0; i < values.outlet_prices.length; i++) {
                const price = values.outlet_prices[i]?.price;

                const isValid = price !== undefined &&
                    /^(0|[1-9]\d*)(\.\d+)?$/.test(price.toString()) &&
                    price.toString().length <= 8;
                
                if (isValid) {
                    outletPricesValid = true;
                } else {
                    outletPricesValid = false;
                    break;
                }
            }

            for (let i = 0; i < values.aggregator_prices.length; i++) {
                const price = values.aggregator_prices[i]?.price;

                const isValid = price !== undefined &&
                    /^(0|[1-9]\d*)(\.\d+)?$/.test(price.toString()) &&
                    price.toString().length <= 8;

                if (isValid) {
                    aggregatorPricesValid = true;
                } else {
                    aggregatorPricesValid = false;
                    break;
                }
            
            }
        }

        return outletPricesValid && aggregatorPricesValid;
    };

    return (
        <>
            <div className="page-header d-flex align-items-center">
                <div className="page-header-left">
                    <Breadcrums data={breadcrumbs} />
                    <h4>{searchParams.get("copy") ? "Add On" : formRef?.current?.values?.outlet_name}</h4>
                </div>
                <div className="page-header-right ms-auto">

                </div>
            </div>
            <Formik
                innerRef={formRef}
                initialValues={{
                    outlet_name: formikData?.outlet_name || "",
                    outlet_name_ar: formikData?.outlet_name_ar || "",
                    brand_id: formikData?.brand_id || [],
                    tax_id: formikData?.tax_id || "",
                    short_code: formikData?.short_code || 0,
                    vat_information: '',
                    email: '',
                    short_description: formikData?.short_description,
                    short_description_ar: formikData?.short_description_ar,
                    location: '',
                    country_id: '',
                    state_id: '',
                    city_id: '',
                    area: '',
                    display_rank: formikData?.display_rank || '',
                    pricingType : formikData?.pricingType || '',
                    outlet_prices: formikData?.outlet_prices || [],
                    aggregator_prices: formikData?.aggregator_prices || [],
                    outlet_prices_specific: formikData?.outlet_prices_specific || []
                    // outlet_name: "",
                    // outlet_name_ar: "",
                    // brand_id: [],
                    // tax_id: "",
                    // short_code: "",
                    // vat_information: '',
                    // email: '',
                    // short_description: '',
                    // short_description_ar: '',
                    // location: '',
                    // country_id: '',
                    // state_id: '',
                    // city_id: '',
                    // area: '',
                    // display_rank: '',
                }}
                enableReinitialize={true}
                validationSchema={Yup.object().shape({
                    // short_code: Yup.number().integer("Price must be a integer").positive("Price must be a positive number.").required("Price is required"),
                })}
                validate={values => {
                    const error = {};


                    if (!values.outlet_name) {
                        error.outlet_name = "Name is required";
                    } else if (values.outlet_name.length > 60) {
                        error.outlet_name = "Name should not exceed 60 characters";
                    }

                    if (!values.outlet_name_ar) {
                        error.outlet_name_ar = "Name (Arabic) is required";
                    } else if (values.outlet_name_ar.length > 60) {
                        error.outlet_name_ar = "Name (Arabic) should not exceed 60 characters";
                    }

                    if (values.short_description && values?.short_description?.length > 250) {
                        error.short_description = 'Short description cannot exceed 250 characters.';
                    }
                    if (values.short_description_ar && values?.short_description_ar?.length > 250) {
                        error.short_description_ar = 'Short description arabic cannot exceed 250 characters.';
                    }



                    if (!(values.brand_id && values?.brand_id?.length)) error.brand_id = "Category is required";
                    // if (!values.short_code) error.short_code = "Price is required";
                    if (values.short_code === undefined || values.short_code === null || values.short_code === '') {
                        error.short_code = "Price is required";
                    }
                    else if (isNaN(values.short_code)) {
                        error.short_code = "Price must be a valid number";
                    }
                    else if (values.short_code < 0) {
                        error.short_code = "Price must be a positive number";
                    }
                    else if (!Number.isInteger(Number(values.short_code))) {
                        error.short_code = "Price must be an integer and cannot be a decimal";
                    }
                    

                    if (page == 1) {
                        if (
                            error.outlet_name ||
                            error.outlet_name_ar ||
                            error.brand_id ||
                            error.sku ||
                            error.short_code ||
                            error.start_date ||
                            error.end_date ||
                            error.start_time ||
                            error.end_time ||
                            error.cooking_minutes
                        ) {
                            setBtnDisable(true);
                        } else {
                            setBtnDisable(false);
                        }
                    }
                    if (page == 2) {
                        if (values?.pricingType === "fixed") {
                            setBtnDisable(!isAllPriceFilled(values));
                        } else {
                            setBtnDisable(false);
                        }
                    }
                    if (page == 3) {
                        const emptyOutletDropdown = values.outlet_prices_specific.find(outletSpecific => outletSpecific.outlet.length == 0);
                        if (emptyOutletDropdown && values.outlet_prices_specific.length > 1) {
                            setBtnDisable(true);
                        } else {
                            setBtnDisable(false);
                        }
                    }

                    console.log(error, values, '=========error running');
                    return error;
                }}


                onSubmit={(values, { setSubmitting }) => {
                    let recipeDataToSend = addOnDataList.map((item) => {
                        return { inventory_id: item?.rawMaterial, order_mode_id: item?.orderMode, quantity: item?.quantity };
                    });
                    
                    setSubmitted(true)
                    let formData = new FormData();
                    formData.append('name', values.outlet_name.trim());
                    formData.append('name_ar', values.outlet_name_ar.trim());
                    formData.append('add_on_category_id', JSON.stringify(values.brand_id));
                    formData.append('tax_group_id', values.tax_id);
                    formData.append('brand_id', getBrandId());
                    formData.append('price', values.short_code);
                    formData.append('vat_information', values.vat_information);
                    formData.append('email', values.email);
                    formData.append('short_description', values.short_description);
                    formData.append('short_description_ar', values.short_description_ar);
                    formData.append('display_rank', values.display_rank);
                    formData.append('id', params.id);

                    // if (addOnDataList?.length > 0) {
                    //     addOnDataList?.map((item) => {
                    //         if (item.rawMaterial != "") {
                    //             mySetData.push({
                    //                 inventory_id: item.rawMaterial.id,
                    //                 quantity: item.quantity,
                    //                 order_mode_id: item.orderMode
                    //             })
                    //         }
                    //     })
                    // }

                    // formData.append('reciepes', JSON.stringify(mySetData));
                    formData.append('reciepes', JSON.stringify(recipeDataToSend));
                    formData.append('company_id', getCompany().company_id);

                    // grouping_key goes back only for groups loaded from the backend, and only on update (a copy creates new groups)
                    const isUpdate = !searchParams.get('copy');
                    const defaultGroupingKey = showDefault?.add_on_outlet_default_prices?.find((item) => item.grouping_key)?.grouping_key;
                    const dataToSend = {
                        ...(isUpdate && defaultGroupingKey && { grouping_key: defaultGroupingKey }),
                        orderMode: values?.outlet_prices?.map((price) => {
                            return {
                                order_mode_id: price.order_mode_id,
                                price: parseFloat(price.price) || 0,
                            };
                        }),
                        aggregator: values?.aggregator_prices?.map((price) => {
                            return {
                                aggregator_id: price.aggregator_id,
                                price: parseFloat(price.price) || 0,
                            };
                        }),
                    };
                    formData.append("default_outlet_prices", JSON.stringify(dataToSend));
                    const specificOutletPrices = (values.outlet_prices_specific || [])
                        .map((record) => ({
                            ...(isUpdate && record.grouping_key && { grouping_key: record.grouping_key }),
                            outlet: record.outlet,
                            orderMode: record?.orderMode?.map((price) => ({
                                order_mode_id: price.order_mode_id,
                                price: price.price === "" || price.price == null ? "" : parseFloat(price.price),
                            })) || [],
                            aggregator: record?.aggregator?.map((price) => ({
                                aggregator_id: price.aggregator_id,
                                price: price.price === "" || price.price == null ? "" : parseFloat(price.price),
                            })) || [],
                        }));
                    formData.append(
                        "specific_outlet_prices",
                        JSON.stringify(specificOutletPrices)
                    );
                    formData.append("pricing_type", values.pricingType);

                    if (!searchParams.get('copy')) {
                        EditAddOn(formData).then(response => {
                            setSubmitting(false);
                            setSubmitted(false);
                            if (response.data.status === 1 || response.data.status === "1") {
                                Swal.fire({
                                    customClass: 'swal-wide',
                                    icon: 'success',
                                    title: response.data.message,
                                    showConfirmButton: false,
                                    timer: 1500,
                                    toast: true,
                                    position: 'top-right',
                                });
                                setTimeout(() => {
                                    navigate(`/company/menu/menu/add_ons/list/${searchParams.get('pageno') || 1}`)
                                }, 1000);
                            } else {
                                Swal.fire({
                                    customClass: 'swal-wide',
                                    icon: 'error',
                                    title: response.data.message,
                                    showConfirmButton: false,
                                    timer: 5000,
                                    toast: true,
                                    position: 'top-right',
                                })
                                setSubmitted(false)
                            }
                        }).catch(error => {
                            console.log("error ====> ", error);
                        })
                    } else {
                        CreateAddOn(formData).then(response => {
                            setSubmitting(false);
                            setSubmitted(false);
                            if (response.data.status === 1 || response.data.status === "1") {
                                Swal.fire({
                                    customClass: 'swal-wide',
                                    icon: 'success',
                                    title: response.data.message,
                                    showConfirmButton: false,
                                    timer: 1500,
                                    toast: true,
                                    position: 'top-right',
                                });
                                setTimeout(() => {
                                    navigate(`/company/menu/menu/add_ons/list/${searchParams.get('pageno') || 1}`)
                                }, 1000);
                            } else {
                                Swal.fire({
                                    customClass: 'swal-wide',
                                    icon: 'error',
                                    title: response.data.message,
                                    showConfirmButton: false,
                                    timer: 5000,
                                    toast: true,
                                    position: 'top-right',
                                })
                                setSubmitted(false)
                            }
                        }).catch(error => {
                            console.log("error ====> ", error);
                        })
                    }
                }}


            >{({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                setFieldValue,
            }) => (
                <form onSubmit={handleSubmit}>
                    <div className='steps'>
                        <ul>
                            <li className={`step step-1 ${activeStep >= 1 ? 'active' : ''}`} style={{ cursor: 'pointer' }} onClick={() => handleStepChange(1)}>
                                <span>1</span><p>Add-On</p>
                            </li>
                            <li className={`step step-2 ${activeStep >= 2 ? 'active' : ''}`} style={{ cursor: 'pointer' }} onClick={() => handleStepChange(2)}>
                                <span>2</span><p>Pricing</p>
                            </li>
                            <li className={`step step-3 ${activeStep >= 3 ? 'active' : ''}`} style={{ cursor: 'pointer' }} onClick={() => handleStepChange(3)}>
                                <span>3</span><p>Outlet-Pricing</p>
                            </li>
                            <li className={`step step-4 ${activeStep >= 4 ? 'active' : ''}`} style={{ cursor: 'pointer' }} onClick={() => handleStepChange(4)}>
                                <span>4</span><p>Recipe</p>
                            </li>
                            <li className={`step step-5 ${activeStep >= 5 ? 'active' : ''}`} style={{ cursor: 'pointer' }} onClick={() => handleStepChange(5)}>
                                <span>5</span><p>Settings</p>
                            </li>

                        </ul>
                    </div>
                    <div className="card custom-card">
                        <div className="card-body">
                            <div className='row row-sm'>
                                <div className="step-1" id="checkout-progress" data-current-step="1" style={{ display: 'none' }}>
                                    <div className="progress-bar">
                                        <div className="step step-1 active"><span> 1</span>
                                            <div className="fa fa-check opaque"></div>
                                            <div className="step-label"> Add-On</div>
                                        </div>
                                        <div className="step step-2"><span> 2</span>
                                            <div className="fa fa-check opaque"></div>
                                            <div className="step-label"> Pricing</div>
                                        </div>
                                        <div className="step step-3"><span> 3</span>
                                            <div className="fa fa-check opaque"></div>
                                            <div className="step-label"> Outlet-Pricing</div>
                                        </div>
                                        <div className="step step-4"><span> 4</span>
                                            <div className="fa fa-check opaque"></div>
                                            <div className="step-label"> Recipe</div>
                                        </div>
                                        <div className="step step-5"><span> 5</span>
                                            <div className="fa fa-check opaque"></div>
                                            <div className="step-label">Settings</div>
                                        </div>

                                    </div> 
                                </div>

                                <section id="section1" className="section1" style={{ display: 'block' }}>
                                    <div className='row'>
                                        <div className='col-lg-6 text-center form-group'>
                                            <label htmlFor='outlet_name' className='text-left d-flex'>Name <span className="requirestar">*</span></label>

                                            <input name='outlet_name' id="outlet_name" type='text' onChange={handleChange} onBlur={handleBlur} value={values.outlet_name} className='form-control' autoComplete='off' placeholder='Enter Name' />
                                            <span className='text-danger d-flex text-left'>{errors.outlet_name && touched.outlet_name && errors.outlet_name}</span>
                                        </div>
                                        <div className='col-lg-6 text-center form-group'>
                                            <label htmlFor='outlet_name_ar' className='text-left d-flex'>Name (arabic) <span className="requirestar">*</span></label>
                                            <input name='outlet_name_ar' id="outlet_name_ar" type='text' onChange={handleChange} onBlur={handleBlur} value={values.outlet_name_ar} className='form-control' autoComplete='off' placeholder='Enter Name in Arabic' />
                                            <span className='text-danger d-flex text-left'>{errors.outlet_name_ar && touched.outlet_name_ar && errors.outlet_name_ar}</span>
                                        </div>

                                        <div className='col-lg-6 text-center form-group mt-3'>
                                            <label htmlFor='brand_id' className='text-left d-flex'>
                                                Category: <span className="requirestar">*</span>
                                            </label>
                                            {/* <Dropdown
                                                className='form-control'
                                                id="brand_id"
                                                placeholder='Select category'
                                                search
                                                fluid
                                                selection
                                                options={brandOptions}
                                                value={values.brand_id}
                                                onChange={(event, data) => setFieldValue("brand_id", data.value)}
                                            /> */}
                                            <CustomMultiSelect data={brandList} form={formRef?.current} name='brand_id' overFlowVisibleOptions={1} menuClassName="popup-select" />

                                            <span className='text-danger d-flex text-left'>
                                                {errors.brand_id && touched.brand_id && errors.brand_id}
                                            </span>
                                        </div>

                                        <div className='col-lg-6 text-center form-group mt-3'>
                                            <label htmlFor='short_code' className='text-left d-flex'>Price:<span className="requirestar">*</span></label>
                                            <input
                                                name='short_code'
                                                id="short_code"
                                                type='number'
                                                onChange={(e) => {
                                                    handleChange(e);
                                                    const newPrice = e.target.value;
                                                    if (values?.outlet_prices?.length) {
                                                        setFieldValue(
                                                            "outlet_prices",
                                                            values.outlet_prices.map((p) => ({ ...p, price: newPrice }))
                                                        );
                                                    }
                                                    if (values?.aggregator_prices?.length) {
                                                        setFieldValue(
                                                            "aggregator_prices",
                                                            values.aggregator_prices.map((p) => ({ ...p, price: newPrice }))
                                                        );
                                                    }
                                                    if (values?.outlet_prices_specific?.length) {
                                                        setFieldValue(
                                                            "outlet_prices_specific",
                                                            values.outlet_prices_specific.map((rec) => ({
                                                                ...rec,
                                                                orderMode: rec?.orderMode?.map((m) => ({ ...m, price: newPrice })),
                                                                aggregator: rec?.aggregator?.map((a) => ({ ...a, price: newPrice })),
                                                            }))
                                                        );
                                                    }
                                                }}
                                                onBlur={handleBlur}
                                                value={values.short_code}
                                                className='form-control'
                                                autoComplete='off'
                                                placeholder='Enter Price'
                                            />
                                            <span className='text-danger d-flex text-left'>{errors.short_code && touched.short_code && errors.short_code}</span>

                                        </div>
                                        <div className='col-lg-6 text-center form-group mt-3'>
                                            <label htmlFor='tax_id' className='d-flex'>Add on display rank :</label>
                                            <input id="display_rank" type='number' className='form-control' name='display_rank' onChange={handleChange} onBlur={handleBlur} value={values.display_rank} />
                                            <span className='text-danger d-flex'>{errors.display_rank && touched.display_rank && errors.display_rank}</span>
                                        </div>
                                        <div className='col-lg-6 text-center form-group mt-3'></div>

                                        <div className='col-lg-6 text-center form-group mt-3'>
                                            <label htmlFor='short_description' className='text-left d-flex'>Short description : </label>
                                            <textarea name='short_description' id="short_description" rows="2" type='text' onChange={handleChange} onBlur={handleBlur} value={values.short_description} className='form-control' />
                                            <span className='text-danger d-flex text-left'>{errors.short_description && touched.short_description && errors.short_description}</span>
                                        </div>
                                        <div className='col-lg-6 text-center form-group mt-3'>
                                            <label htmlFor='short_description_ar' className='text-left d-flex'>Short description (arabic) : </label>
                                            <textarea name='short_description_ar' id="short_description_ar" rows="2" type='text' onChange={handleChange} onBlur={handleBlur} value={values.short_description_ar} className='form-control' />
                                            <span className='text-danger d-flex text-left'>{errors.short_description_ar && touched.short_description_ar && errors.short_description_ar}</span>
                                        </div>
                                        <div className='row'>

                                        </div>
                                    </div>
                                </section>

                                <section id="section2" className="section2" style={{ display: 'none' }}>
                                    <div className="add-price-box">
                                        <h4 className="mb-2 heading-text">Pricing Type</h4>
                                        <div className="col-md-12">
                                        <div className="row">
                                            <div className="col-md-6">
                                            <div className="form-group form-group-flex mt-2 d-flex align-items-center">
                                                <div className="form-check form-check-inline">
                                                <input
                                                    className="form-check-input cp"
                                                    type="radio"
                                                    name="pricingType"
                                                    id="fixed"
                                                    value="fixed"
                                                    onChange={(e) => {
                                                    handleChange(e);
                                                    setTimeout(() => {
                                                        setRefreshPricing(!refreshPricing);
                                                    }, 100);
                                                    }}
                                                    checked={values?.pricingType === "fixed"}
                                                />
                                                <label
                                                    className="form-check-label cp"
                                                    htmlFor="fixed"
                                                >
                                                    Fixed
                                                </label>
                                                </div>
                                                <div className="form-check form-check-inline">
                                                <input
                                                    className="form-check-input cp"
                                                    type="radio"
                                                    name="pricingType"
                                                    id="ask_for_price"
                                                    value="ask_for_price"
                                                    onChange={(e) => {
                                                    handleChange(e);
                                                    setTimeout(() => {
                                                        setRefreshPricing(!refreshPricing);
                                                    }, 100);
                                                    }}
                                                    checked={
                                                    values?.pricingType === "ask_for_price"
                                                    }
                                                />
                                                <label
                                                    className="form-check-label cp"
                                                    htmlFor="ask_for_price"
                                                >
                                                    Ask for price
                                                </label>
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                    {
                                        values.pricingType !== "ask_for_price" 
                                        ? (
                                        <>
                                            <h4 className="mt-4 heading-text">
                                            Add Price for Outlet
                                            </h4>
                                            {allOrderMode.map((record, i) => (
                                            <div key={i} className="add-price-box">
                                                <div className="row">
                                                <div className="col-md-12">
                                                    <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="form-group form-group-flex mb-3">
                                                        <label htmlFor={`price_${i}`}>
                                                            {capitalizeAllFirstLetters(
                                                            SpecialCharacter(record?.name)
                                                            )}
                                                        </label>
                                                        <Field
                                                            className="form-control mb-2"
                                                            type="number"
                                                            name={`outlet_prices[${i}].price`}
                                                            id={`price_${i}`}
                                                            placeholder={`Enter ${SpecialCharacter(
                                                            record?.name
                                                            )} price`}
                                                        />
                                                        <Field
                                                            type="hidden"
                                                            name={`outlet_prices[${i}].order_mode_id`}
                                                            value={record?.id || ""}
                                                        />
                                                        </div>
                                                    </div>
                                                    </div>
                                                </div>
                                                </div>
                                            </div>
                                            ))}
                                            <h4 className="mb-2 heading-text">Outsource Pricing</h4>
                                            {allAggregator.map((item, index) => (
                                            <div key={index} className="add-price-box">
                                                <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group form-group-flex mb-3">
                                                    <label htmlFor={`outsource_price_${index}`}>
                                                        {capitalizeAllFirstLetters(
                                                        SpecialCharacter(item?.name)
                                                        )}
                                                    </label>
                                                    <Field
                                                        className="form-control mb-2"
                                                        type="number"
                                                        name={`aggregator_prices[${index}].price`}
                                                        id={`outsource_price_${index}`}
                                                        placeholder={`Enter ${SpecialCharacter(
                                                        item?.name
                                                        )} price`}
                                                    />
                                                    <Field
                                                        type="hidden"
                                                        name={`aggregator_prices[${index}].aggregator_id`}
                                                        value={item?.id || ""}
                                                    />
                                                    </div>
                                                </div>
                                                </div>
                                            </div>
                                            ))}
                                        </>
                                        ) 
                                        : null
                                    }
                                </section>

                                <section id="section3" className="section3" style={{ display: "none" }}>
                                    <div>
                                        {values.pricingType !== "ask_for_price" ? (
                                        <>
                                            {values?.outlet_prices_specific?.map((record, i) => {
                                            const prefix = `outlet_prices_specific[${i}]`;
                                            return (
                                                <div key={i}>
                                                    {/* Ordermode pricing */}    
                                                    <div className="add-price-box">
                                                        {/* Remove sits in each group's own header, so any group, the first one
                                                            included, can be dropped without scrolling to its end */}
                                                        <div className="row">
                                                            {/* same width as the fields below, so Remove lines up with their right edge */}
                                                            <div className="col-md-6">
                                                                <div className="d-flex align-items-center justify-content-between mt-4 mb-3">
                                                                    <h4 className="heading-text mb-0">Pricing Group {i + 1}<span className="price-group-sub">Add price for outlet</span></h4>
                                                                    <button
                                                                        type="button"
                                                                        className="price-group-remove"
                                                                        title="Remove this outlet price group"
                                                                        onClick={() =>
                                                                            confirmRemovePriceBox(
                                                                                i,
                                                                                setFieldValue,
                                                                                values.outlet_prices_specific
                                                                            )
                                                                        }
                                                                    >
                                                                        <i className="ti ti-trash"></i>Remove
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <div className="row">
                                                                <div className="col-md-6">
                                                                    <div className="form-group mb-3">
                                                                    <label htmlFor={`outlet_${i}`}>
                                                                        Select Outlet {record?.outlet?.length ? <span className="outlet-price-count">({record.outlet.length} selected)</span> : null}
                                                                    </label>
                                                                    {dataFormatted ? (
                                                                        <TagPicker
                                                                        data={outListData.filter(
                                                                            (outlet) => {
                                                                                return (
                                                                                    outlet.valid == true ||
                                                                                    record.outlet.includes(
                                                                                    outlet.value
                                                                                )
                                                                            );
                                                                            }
                                                                        ).sort((a, b) => compareOutletCodes(a.value, b.value))}
                                                                        value={[...record.outlet].sort(compareOutletCodes)} // controlled: groups are keyed by index, so after a group is removed the picker must follow this group\'s own outlets
                                                                        className="form-control form-control-select outlet-price-picker"
                                                                        onChange={(selectedOutlets) => {
                                                                            // Ensure the selected outlets are correctly formatted (array of IDs)
                                                                            setFieldValue(`${prefix}.outlet`, selectedOutlets); // or whatever field name is appropriate
                                                                            onChangeOutlet(record.outlet, selectedOutlets);
                                                                        }}
                                                                        renderMenu={(menu) => {
                                                                            // Select All row, same as CustomMultiSelect: picks every outlet this group can use (not the ones taken by other groups)
                                                                            const outletIds = outListData
                                                                                .filter((outlet) => outlet.valid == true || record.outlet.includes(outlet.value))
                                                                                .map((outlet) => outlet.value);
                                                                            const allSelected = outletIds.length > 0 && record.outlet.length === outletIds.length;
                                                                            const toggleAll = () => {
                                                                                const selectedOutlets = allSelected ? [] : outletIds;
                                                                                setFieldValue(`${prefix}.outlet`, selectedOutlets);
                                                                                onChangeOutlet(record.outlet, selectedOutlets);
                                                                            };
                                                                            return (
                                                                                <div>
                                                                                    <div className="rs-picker-list-item cp outlet-price-select-all">
                                                                                        <div className={"rs-check-item rs-checkbox e_none" + (allSelected ? " rs-checkbox-checked" : record.outlet.length ? " rs-checkbox-indeterminate" : "")} onClick={toggleAll}>
                                                                                            <div className="rs-checkbox-checker">
                                                                                                <label>
                                                                                                    <span className="rs-checkbox-control">
                                                                                                        <input type="checkbox" checked={allSelected} readOnly />
                                                                                                        <span className="rs-checkbox-inner"></span>
                                                                                                    </span>
                                                                                                    <span className="rs-checkbox-label">{allSelected ? "Unselect All" : "Select All"}</span>
                                                                                                </label>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    {menu}
                                                                                </div>
                                                                            );
                                                                        }}
                                                                        cleanable={false}
                                                                        placeholder="Select outlet"
                                                                        />
                                                                    ) : null}
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6"></div>
                                                                <div className="col-md-6">
                                                                    {record?.orderMode?.map(
                                                                    (mode, index) => (
                                                                        <div
                                                                        key={index}
                                                                        className="form-group form-group-flex mb-3"
                                                                        >
                                                                        <label
                                                                            htmlFor={`mode_${mode.slug}_${i}_${index}`}
                                                                        >
                                                                            {capitalizeAllFirstLetters(
                                                                            SpecialCharacter(mode?.name)
                                                                            )}
                                                                        </label>
                                                                        <input
                                                                            type="hidden"
                                                                            name={`${prefix}.orderMode[${index}].slug`}
                                                                            value={mode.slug}
                                                                        />
                                                                        <Field
                                                                            className="form-control mb-2"
                                                                            type="number"
                                                                            name={`${prefix}.orderMode[${index}].price`}
                                                                            id={`mode_${mode.slug}_${i}_${index}`}
                                                                            placeholder={`Enter ${SpecialCharacter(
                                                                            mode?.name
                                                                            )} price`}
                                                                            value={mode.price}
                                                                        />
                                                                        </div>
                                                                    )
                                                                    )}
                                                                </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* Outsource pricing */}
                                                    <div className="add-price-box">
                                                        <h4 className="mb-2 heading-text">
                                                        Outsource Pricing
                                                        </h4>
                                                        <div className="row">
                                                            {record?.aggregator?.map((agg, index) => (
                                                                <div key={index} className="col-md-6">
                                                                <div className="form-group form-group-flex mb-3">
                                                                    <label
                                                                        htmlFor={`aggregator_${agg.slug}_${i}_${index}`}
                                                                    >
                                                                    {capitalizeAllFirstLetters(
                                                                        SpecialCharacter(agg?.name)
                                                                    )}
                                                                    </label>
                                                                    <input
                                                                        type="hidden"
                                                                        name={`${prefix}.aggregator[${index}].slug`}
                                                                        value={agg.slug}
                                                                    />
                                                                    <Field
                                                                        className="form-control mb-2"
                                                                        type="number"
                                                                        name={`${prefix}.aggregator[${index}].price`}
                                                                        id={`aggregator_${agg.slug}_${i}_${index}`}
                                                                        placeholder={`Enter ${SpecialCharacter(
                                                                            agg?.name
                                                                        )} price`}
                                                                        value={agg?.price}
                                                                    />
                                                                </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                    {/* Actions */}
                                                    <div className="align-items-center">
                                                        {i ===
                                                        values?.outlet_prices_specific.length - 1 &&
                                                        (outListData.find(
                                                            (outlet) => outlet.valid === true
                                                        ) ? (
                                                            values.outlet_prices_specific[i].outlet.length ?
                                                            <button
                                                                type="button"
                                                                className="btn btn-primary"
                                                                onClick={() =>
                                                                addPriceBox(
                                                                    setFieldValue,
                                                                    values.outlet_prices_specific
                                                                )
                                                                }
                                                                style={{
                                                                width: "12%",
                                                                marginLeft: "0",
                                                                }}
                                                            >
                                                                + Add price for outlet
                                                            </button> : null
                                                        ) : (
                                                            <div className="alert alert-warning">
                                                            All outlets are selected. Please{" "}
                                                            <Link to="/company/business/outlet/add">
                                                                create an outlet
                                                            </Link>{" "}
                                                            to add more pricing.
                                                            </div>
                                                        ))}
                    
                                                        {/* <button    
                                                                                            type="button"
                                                                                            className="btn btn-primary"
                                                                                            onClick={() => addPriceBox(setFieldValue, values.outlet_prices_specific)}
                                                                                            style={{ width: '12%', marginLeft: i !== 0 ? '10px' : '0' }}
                                                                                        >
                                                                                            + Add price for outlet
                                                                                        </button> */}
                                                    </div>
                                                </div>
                                            );
                                            })}
                                            {/* every group can be removed, so offer a way back from none */}
                                            {!values?.outlet_prices_specific?.length && outListData.find((outlet) => outlet.valid === true) ? (
                                                <button
                                                    type="button"
                                                    className="btn btn-primary mt-4"
                                                    onClick={() => addPriceBox(setFieldValue, values.outlet_prices_specific || [])}
                                                >
                                                    + Add price for outlet
                                                </button>
                                            ) : null}
                                        </>
                                        ) : (
                                            <p style={{ color: "red" }}>
                                                You are selecting the pricing as ask for
                                                price,therefore outlet pricing is not applicable.
                                            </p>
                                        )}
                                    </div>
                                </section>

                                <section id="section4" className="section4" style={{ display: 'none' }}>
                                    
                                     <div className="d-flex justify-content-end">

                                        <button className="btn btn-primary btn-lg" type="button" onClick={() => setShow(true)} style={{ marginTop: '10px' }}>
                                            Add New Recipe
                                        </button>

                                        {/* <button className="btn btn-primary btn-lg" type="button" onClick={() => setShow(true)} style={{ marginTop: '10px' }}>
                                            Copy Recipe
                                        </button> */}
                                        {/* <button
                                            className="btn btn-primary btn-lg ms-3"
                                            type="button"
                                            onClick={() => { setShowMenuItems(true) }}
                                            style={{ marginBottom: '10px' }}
                                        >
                                            Copy Recipe
                                        </button> */}
                                    </div>

                                    <div className="tabler-wrap">
                                        {/* <h2>Recipe List</h2> */}
                                        <table className="table table-custom">
                                            <thead>
                                                <tr>
                                                    <th>Raw Material</th>
                                                    <th>Usage UOM</th>
                                                    <th>Quantity</th>
                                                    <th>Price</th>
                                                    <th>Calories</th>
                                                    <th>Order Mode</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            
                                            <tbody>
                                                {addOnDataList && addOnDataList?.length ? (
                                                    addOnDataList?.map((recipe, index) => (
                                                        <tr key={index}>
                                                            <td>{capitalizeAllFirstLetters(getRecordFromList(inventoryList, recipe?.rawMaterial)?.item_name)}</td>
                                                            <td>{recipe?.usageUOM}</td>
                                                            <td>{recipe?.quantity}</td>
                                                            <td>{recipe?.price}</td>
                                                            <td>{recipe?.calories}</td>
                                                            {/* <td>{capitalizeAllFirstLetters(getRecordFromList(orderList, recipe?.orderMode)?.name)}</td> */}
                                                            <td>
                                                                {
                                                                    recipe?.orderMode?.map((item, i) => {
                                                                        return <span key={i}>{capitalizeAllFirstLetters(SpecialCharacter(getRecordFromList(allOrderMode, item)?.name))}{i < (recipe?.orderMode?.length - 1) ? ", " : ""}</span>
                                                                    })
                                                                }

                                                            </td>
                                                            <td className='d-flex'>
                                                                <button type='button' className='btn btn-primary me-3 mt-2' onClick={() => handleEditItem(index)}>Edit</button>
                                                                <button type='button' className='btn btn-danger mt-2' onClick={() => handleRemoveItem(index)}>Remove</button>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="7" className="text-center">No recipes found</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>

                                    </div>
                                </section>

                                <section id="section5" className="section5" style={{ display: 'none' }}>
                                    <div className='row'>
                                        <div className='col-lg-8 form-group' style={{ width: '50%' }}>
                                            <div className='form-group mt-3'>
                                                <label htmlFor='tax_id' className='d-flex'>Tax Group :</label>
                                                <select id="tax_id" className='form-control' name='tax_id' onChange={handleChange} onBlur={handleBlur} value={values.tax_id}>

                                                    <option value="">Select Tax Group</option>
                                                    {taxList?.length ? taxList?.map((row) => (
                                                        <option key={row.id} value={row.id}>{row?.name}</option>
                                                    )) : ''}
                                                </select>
                                                <span className='text-danger d-flex'>{errors.tax_id && touched.tax_id && errors.tax_id}</span>
                                            </div>
                                        </div>
                                    </div>

                                </section>

                                <div className="button-container mt-4 p-10 d-flex justify-content-between align-items-center">
                                    <div>
                                        {page > 1 && (
                                            <button className="btn btn-outline-primary btn-prev" type="button" onClick={prevStep}>Back</button>
                                        )}
                                        {page < 5 && (
                                            <button className="btn btn-next btn-primary ms-2" type="button" onClick={nextStep} disabled={btnDisable} > Next</button>
                                        )}
                                    </div>
                                    <button className="btn btn-primary ms-2 btn-submit" onClick={() => { setBtnClicked(true) }} type="submit">Submit</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            )}
            </Formik>

            <ToastContainer
                position="top-right"
                hideProgressBar={false}
                autoClose={true | 1000}
                newestOnTop={true}
                closeOnClick={false}
                draggable={false}
                rtl={false}
            />
         
            <Modal show={show} onHide={handleClose} backdrop={'static'} >
                <Modal.Header closeButton>
                    <Modal.Title>{recipeEditableIndex === null ? "Add" : "Edit"} New Recipe</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {/* <Form onSubmit={(e) => saveData(e)}>
                     */}
                    <div>
                        <form onSubmit={formik.handleSubmit}>

                            <div className='col-lg-6 text-center form-group mb-3 w-100' controlId="rawMaterial">
                                <label className='text-left d-flex'>Raw Material</label>
                                {/* <select as="select" className='form-control' name="rawMaterial" onBlur={formik?.handleBlur} value={formik?.values?.rawMaterial} onChange={handleChangeModel} >
                                    <option value="">Select Raw Material</option>
                                    {inventoryList.map((order) => {
                                        const isDisabled = addOnDataList.some(item => item.rawMaterial && Number(item.rawMaterial) === order.id);
                                        return (
                                            <option key={order.id} value={order.id} disabled={isDisabled}>
                                                {capitalizeAllFirstLetters(order.item_name)}
                                                {isExpired(order.created_at, order.self_life) && ' (Expired)'}
                                            </option>
                                        );
                                    })}

                                </select> */}

                                {/* <Select
                                    options={inventoryList}
                                    value={inventoryList.find((opt) => opt.value === formik?.values?.rawMaterial) || null}
                                    onChange={(option) => handleChangeModel(option.value)}
                                    placeholder="Select Raw Material"
                                    isSearchable={true}   // 🔍 search enabled
                                    className="cursor-pointer" // whole dropdown shows pointer
                                    styles={{
                                        option: (provided, state) => ({
                                            ...provided,
                                            cursor: state.isDisabled ? "not-allowed" : "pointer", // ✅ pointer on options
                                        }),
                                    }}
                                    filterOption={(option, rawInput) => {
                                        const input = rawInput.toLowerCase();
                                        return (
                                            option.label.toLowerCase().includes(input) ||
                                            String(option.value).toLowerCase().includes(input)
                                        );
                                    }}
                                /> */}
                                
                                 {/* Search input */}
                                {/* <input
                                    className="form-control mb-2"
                                    placeholder="Search raw material..."
                                    value={rawMaterialSearch}
                                    onChange={(e) => setRawMaterialSearch(e.target.value)}
                                /> */}

                                {/* <Dropdown
                                    options={
                                        inventoryList
                                            .filter(inv => !inv.isDisabled)
                                            .filter(inv =>
                                                inv.label?.toLowerCase().includes(rawMaterialSearch.toLowerCase())
                                            )
                                            .map(inventory => ({
                                                label: capitalizeAllFirstLetters(inventory.label),
                                                value: inventory.value,
                                            }))
                                    }
                                    value={
                                        inventoryList.find(
                                            opt => opt.value === formik?.values?.rawMaterial
                                        )
                                    }
                                    onChange={(option) => {
                                        handleChangeModel(option.value);
                                        setRawMaterialSearch("");
                                    }}
                                    placeholder="Select Raw Material"
                                    className="react-dropdown"
                                    controlClassName="react-dropdown-control"
                                    menuClassName="react-dropdown-menu"
                                /> */}

                                <Dropdown
                                    placeholder="Select Raw Material"
                                    fluid
                                    search={searchRawMaterial}
                                    selection
                                    options={inventoryList.map(inv => ({
                                        key: inv.value,
                                        text: `${capitalizeAllFirstLetters(inv.label)}${inv.sku ? ` (${inv.sku})` : ''}`,
                                        value: inv.value,
                                        disabled: inv.isDisabled == true,
                                    }))}
                                    value={formik.values.rawMaterial || null}
                                    onChange={(e, { value }) => handleChangeModel(value)}
                                />

                            </div>

                            <Form.Group className="mb-3" controlId="usageUOM">
                                <Form.Label>Unit of Measure</Form.Label>
                                <Form.Control disabled type="text" name="usageUOM" placeholder="Enter Unit of Measure" value={formik?.values?.usageUOM} onChange={formik?.handleChange} />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="quantity">
                                <Form.Label>Quantity</Form.Label>
                                <Form.Control type="number" name="quantity" onBlur={formik?.handleBlur} placeholder="Enter Quantity" value={formik?.values?.quantity} onChange={(event) => { formik?.handleChange(event); onChangeQuantity(event.target.value, formik.values) }} />
                                <span className="text-danger d-flex text-left">{formik.errors.quantity && formik.touched.quantity && formik.errors.quantity} </span>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="price">
                                <Form.Label>Price</Form.Label>
                                <Form.Control disabled type="number" name="price" placeholder="Enter Price" value={formatToTwoDecimals(formik?.values?.price)} onChange={formik?.handleChange} />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="calories">
                                <Form.Label>Calories</Form.Label>
                                <Form.Control disabled type="number" name="calories" placeholder="Enter Calories" value={formatToTwoDecimals(formik?.values?.calories)} onChange={formik?.handleChange} />
                            </Form.Group>

                            <div className='col-lg-6 text-center form-group mb-3 w-100' controlId="orderMode">
                                <label className='text-left d-flex'>Order Mode</label>
                                <CustomMultiSelect data={allOrderMode.map((item) => {
                                    return {
                                        label: capitalizeFirstLetter(SpecialCharacter(item.name)),
                                        value: item.id
                                    }
                                })} form={formik} name='orderMode' overFlowVisibleOptions={1} menuClassName="popup-select" />
                            </div>

                            <Button variant="primary" onClick={resetForm} style={{ marginRight: '10px' }}> Cancel</Button>
                            {/* <Button variant="primary" type='submit' disabled={formData.orderMode == '' || formData.calories == '' || formData.price == '' || formData.quantity == '' || formData.usageUOM == "" || formData.rawMaterial == ""}>
                            {recipeEditableIndex === null ? "Add" : "Edit"} Recipe
                        </Button> */}
                            <Button variant="primary" type='submit' disabled={!formik.dirty || !formik.isValid}>
                                {recipeEditableIndex === null ? "Add" : "Update"} Recipe
                            </Button>
                            {/* </Form> */}
                        </form>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default AddOnsEdit
